<template lang="pug">
	b-form-group(:label="_field.label" :description="_field.help")
		div.mb-2(v-if="(typeof value) === 'string'")
			| Файл:
			|
			a(:href="value" target="_blank") скачать
		div.mb-2(v-else)
			b-alert(variant="warning" show) скачивание будет доступно после отправки формы

		b-input-group
			b-input-group-prepend(v-if="_field.icon")
				b-input-group-text
					i(:class='_field.icon')
			b-form-file(:value="value" :name="_field.name" v-bind="_field.attrs" @input.native="$emit('input', $event.target.files[0])" :state="_checkState(_field.name)")
			b-form-invalid-feedback(:state="_checkState(_field.name)") {{ _invalidFeedback(_field.name) }}

</template>
<script>
	export default {
		name: 'w-file',
		props: ['value','_field','_checkState', '_invalidFeedback'],
	}
</script>
